// extracted by mini-css-extract-plugin
export default {"actionsView":"styles_actionsView__ydXM8","singleAction":"styles_singleAction__-iDop","ui-spin":"styles_ui-spin__NFluv"};